export type PageControlItem = number | 'ellipsis';

export function visiblePageNumbers(currentPage: number, pageCount: number): PageControlItem[] {
  if (pageCount <= 7) {
    return Array.from({ length: pageCount }, (_, index) => index + 1);
  }

  const pages = new Set([1, pageCount, currentPage - 1, currentPage, currentPage + 1]);
  if (currentPage <= 4) {
    for (let page = 2; page <= 5; page += 1) pages.add(page);
  }
  if (currentPage >= pageCount - 3) {
    for (let page = pageCount - 4; page < pageCount; page += 1) pages.add(page);
  }

  const validPages = [...pages]
    .filter((page) => page >= 1 && page <= pageCount)
    .sort((left, right) => left - right);
  const controls: PageControlItem[] = [];
  for (const page of validPages) {
    const previous = controls.at(-1);
    if (typeof previous === 'number' && page - previous > 1) controls.push('ellipsis');
    controls.push(page);
  }
  return controls;
}
